"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../component");
class CallbackComponent extends component_1.default {
    callback;
    defaultOptions = {};
    constructor(callback) {
        super();
        this.callback = callback;
    }
    ;
    get(_, printer) {
        return printer.inspect(this.callback());
    }
    ;
}
exports.default = CallbackComponent;
